import React, { useEffect, useRef, useState } from 'react';
import { Link } from 'react-router-dom';
import useOutsetaAuth from '../hooks/useOutsetaAuth';
import { MEMBERS_PATH } from '../membersPath';
import './Header.css';

const Header = () => {
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
  const [accountMenuOpen, setAccountMenuOpen] = useState(false);
  const accountMenuRef = useRef(null);
  const { isAuthenticated, user, login, openProfile } = useOutsetaAuth();

  const firstName = user && user.given_name;

  const closeMobileMenu = () => {
    setMobileMenuOpen(false);
  };

  // Close the account menu on a click outside it or on Escape.
  useEffect(() => {
    if (!accountMenuOpen) return undefined;
    const onClick = (e) => {
      if (accountMenuRef.current && !accountMenuRef.current.contains(e.target)) {
        setAccountMenuOpen(false);
      }
    };
    const onKey = (e) => {
      if (e.key === 'Escape') setAccountMenuOpen(false);
    };
    document.addEventListener('mousedown', onClick);
    document.addEventListener('keydown', onKey);
    return () => {
      document.removeEventListener('mousedown', onClick);
      document.removeEventListener('keydown', onKey);
    };
  }, [accountMenuOpen]);

  const handleLogin = () => {
    closeMobileMenu();
    login();
  };

  const handleOpenProfile = () => {
    setAccountMenuOpen(false);
    closeMobileMenu();
    openProfile();
  };

  return (
    <header className="header">
      <div className="header-main">
        <div className="container">
          <div className="header-content">
            <div className="logo">
              <Link to="/">
                <img src="/images/logo-ebta.png" alt="EBTA" className="logo-img" />
              </Link>
            </div>

            <button
              className={`hamburger-menu ${mobileMenuOpen ? 'active' : ''}`}
              onClick={() => setMobileMenuOpen(!mobileMenuOpen)}
              aria-label="Toggle menu"
            >
              <span></span>
              <span></span>
              <span></span>
            </button>

            <nav className={`main-nav ${mobileMenuOpen ? 'mobile-open' : ''}`}>
              <Link to="/" className="nav-link" onClick={closeMobileMenu}>Home</Link>
              <Link to="/about" className="nav-link" onClick={closeMobileMenu}>Who we are</Link>
              <div className="nav-dropdown">
                <span className="nav-link">What we do</span>
                <div className="dropdown-content">
                  <div className="nav-dropdown nested-dropdown">
                    <Link to="/activities" className="nav-link" onClick={closeMobileMenu}>Activities</Link>
                    <div className="dropdown-content">
                      <Link to="/conferences" onClick={closeMobileMenu}>Conferences</Link>
                      <Link to="/meet-and-learn" onClick={closeMobileMenu}>Meet&Learn</Link>
                      <Link to="/summercamp" onClick={closeMobileMenu}>Summer Camp</Link>
                      <Link to="/awards" onClick={closeMobileMenu}>Awards</Link>
                      <Link to="/research/grant" onClick={closeMobileMenu}>EBTA Research Grant</Link>
                    </div>
                  </div>
                  <Link to="/task-groups" onClick={closeMobileMenu}>Task Groups</Link>
                  <Link to="/research" onClick={closeMobileMenu}>Research</Link>
                  <Link to="/sf-research" onClick={closeMobileMenu}>SFA PubList by EBTA</Link>
                </div>
              </div>
              <Link to="/contact" className="nav-link" onClick={closeMobileMenu}>Contact</Link>
              {isAuthenticated ? (
                <Link to={MEMBERS_PATH} className="nav-link" onClick={closeMobileMenu}>Members area</Link>
              ) : (
                <Link to="/membership" className="nav-link" onClick={closeMobileMenu}>Membership</Link>
              )}

              <div className="nav-actions">
                <Link to="/conferences" className="nav-cta conference-2026" onClick={closeMobileMenu}>
                  Conference 2027
                </Link>

                {isAuthenticated ? (
                  <div className="account-menu" ref={accountMenuRef}>
                    <button
                      type="button"
                      className="nav-outline-btn account-toggle"
                      aria-haspopup="true"
                      aria-expanded={accountMenuOpen}
                      onClick={() => setAccountMenuOpen(!accountMenuOpen)}
                    >
                      {firstName || 'My account'}
                      <span className="account-caret" aria-hidden="true">▾</span>
                    </button>
                    {accountMenuOpen && (
                      <div className="account-dropdown">
                        <button type="button" className="account-dropdown-item" onClick={handleOpenProfile}>
                          My account
                        </button>
                        <a href="#o-logout-link" className="account-dropdown-item">Logout</a>
                      </div>
                    )}
                  </div>
                ) : (
                  <button type="button" className="nav-outline-btn" onClick={handleLogin}>
                    Login
                  </button>
                )}
              </div>
            </nav>
          </div>
        </div>
      </div>
    </header>
  );
};

export default Header;
